module.exports = __webpack_public_path__ + "static/media/crop.865839d5.svg";